<template>
  <div />
</template>

<script lang="ts">
import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import { OptionalCol } from '@/types';
import { global_store } from '@/store';

const global_mutations = global_store.mutations;

@Component
export default class ResizeCols extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  header!: OptionalCol;

  @Prop({ type: String, default: '', required: true })
  storage_name!: '';

  private static isResizeListenerAttached = false;

  private mounted() {
    if (!ResizeCols.isResizeListenerAttached) {
      window.addEventListener('resize', this.handleWindowResize);
      ResizeCols.isResizeListenerAttached = true;
    }
  }

  private beforeDestroy() {
    if (ResizeCols.isResizeListenerAttached) {
      window.removeEventListener('resize', this.handleWindowResize);
      ResizeCols.isResizeListenerAttached = false;
    }
  }

  private handleWindowResize() {
    this.$nextTick(() => {
      global_mutations.RERENDER_TABLES();
    });
  }

  @Watch('header.width')
  on_prop_width_change(new_val: number | string, old_val: number | string) {
    if (!old_val || !new_val || typeof new_val === 'string') {
      this.$nextTick(() => {
        global_mutations.RERENDER_TABLES();
      });

      return;
    }

    const storageItem = localStorage.getItem(this.storage_name);

    if (storageItem !== null) {
      const currentTableStorage = JSON.parse(storageItem);

      const headerWidth: string | number = this.header.width || 0;
      let headerWidthNumber = 0;
      let headerWidthString = '';

      // const resizedCol = this.header.width;

      if (typeof headerWidth === 'number') {
        headerWidthNumber = headerWidth;
        headerWidthString = `${headerWidth}px`;
      } else {
        headerWidthNumber = Number(headerWidth.replace('px', ''));
        headerWidthString = headerWidth;
      }

      const resizedArr = currentTableStorage.map((col: any) => {
        const resized = { ...col };

        let colWidth = col.width;

        if (typeof colWidth === 'string') {
          colWidth = Number(colWidth.replace('px', ''));
        }

        if (col.value === this.header.value && colWidth !== headerWidthNumber) {
          resized.width = headerWidthString;
          global_store.mutations.UPD_CLEAT_LOCALE_STORAGE(false);
        }
        return resized;
      });

      localStorage.setItem(this.storage_name, JSON.stringify(resizedArr));
    }

    this.$emit('finish');
  }
}
</script>
